import { walletConnect as customWalletConnect } from "../connectors/resolveConnectors/walletConnect";
import { coinbaseWallet, walletConnect } from "@wagmi/connectors";
import { metaMaskConnect } from '../connectors/metaMaskConnect';
import { isMobile } from "@layerswap/utils";
import { browserInjected } from "../connectors/browserInjected";
import { HIDDEN_WALLETCONNECT_ID } from "../constants";
/**
 * The package's custom WalletConnect connector used under the hood for
 * registry-wallet connects (per-wallet deep links / QR codes). Hosts that
 * supply an external `wagmiConfig` must include this connector to keep
 * registry wallets available — without it the widget hides the registry
 * lists and only offers the config's own connectors.
 */
export const createHiddenWalletConnectConnector = ({ projectId }) => customWalletConnect({
    id: HIDDEN_WALLETCONNECT_ID,
    name: 'Hidden WalletConnect',
    rdns: '',
    type: 'other',
    mobile: { native: '', universal: '' },
    icon: '',
    projectId,
    showQrModal: false,
});
export const buildEVMConnectors = (walletConnectConfigs) => {
    const isMobilePlatform = isMobile();
    const walletConnectConnector = walletConnect({
        projectId: walletConnectConfigs.projectId,
        showQrModal: isMobilePlatform,
        customStoragePrefix: 'walletConnect',
    });
    const hiddenWalletConnectConnector = createHiddenWalletConnectConnector(walletConnectConfigs);
    const metaMaskConnector = metaMaskConnect({
        dapp: {
            name: walletConnectConfigs.name,
            url: walletConnectConfigs.url,
            iconUrl: walletConnectConfigs.icons[0],
        },
    });
    const coinbaseWalletConnector = coinbaseWallet({
        appName: walletConnectConfigs.name,
        appLogoUrl: walletConnectConfigs.icons[0],
    });
    const browserInjectedConnector = browserInjected();
    return [
        metaMaskConnector,
        coinbaseWalletConnector,
        walletConnectConnector,
        browserInjectedConnector,
        hiddenWalletConnectConnector,
    ];
};
